import { render, staticRenderFns } from "./selectMs.vue?vue&type=template&id=1c0c7bdb&scoped=true"
import script from "./selectMs.vue?vue&type=script&lang=js"
export * from "./selectMs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0c7bdb",
  null
  
)

export default component.exports